import { objectSchema } from "vue-utils"

export interface PagedRequest {
	pageSize: number
	page: number
}

export interface PagedResult {
	totalPages: number
	totalItems: number
	pageSize: number
}
export const PagedResult = objectSchema<PagedResult>({
	totalPages: Number,
	totalItems: Number,
	pageSize: Number,
})
